import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiConstantsService } from './api-constants.service';
import {
  TaxRule,
  TaxRulesCreationParams,
  TaxRulesListParams
} from '~core/models/tax-rules.models';
import { Pagination } from '~core/models/core.models';

@Injectable()
export class TaxRulesService {
  private readonly _http = inject(HttpClient);
  private _apiConstantsService = inject(ApiConstantsService);

  list(params?: TaxRulesListParams): Observable<Pagination<TaxRule>> {
    return this._http.get<Pagination<TaxRule>>(
      this._apiConstantsService.taxRulesUrl,
      {
        params: {
          ...params,
          sort: params?.sort || 'createdAt',
          desc: params?.desc || 'createdAt'
        } as Record<string, any>
      }
    );
  }

  read(taxRuleId: string, params?: TaxRulesListParams): Observable<TaxRule> {
    return this._http.get<TaxRule>(
      `${this._apiConstantsService.taxRulesUrl}/${taxRuleId}`,
      { params }
    );
  }

  create(payload: TaxRulesCreationParams): Observable<TaxRule> {
    return this._http.post<TaxRule>(this._apiConstantsService.taxRulesUrl, {
      ...payload,
      useStateFormViolationHandler: true
    });
  }

  update(
    taxRuleId: string,
    payload: Partial<TaxRulesCreationParams>
  ): Observable<TaxRule> {
    return this._http.put<TaxRule>(
      `${this._apiConstantsService.taxRulesUrl}/${taxRuleId}`,
      { ...payload, useStateFormViolationHandler: true }
    );
  }

  delete(taxRuleId: string): Observable<unknown> {
    return this._http.delete(
      `${this._apiConstantsService.taxRulesUrl}/${taxRuleId}`
    );
  }
}
